export const OLD_IOS_SUBSCRIPTION = 'prod_Ino8JKC8tIhcwN'
export const NEW_MONTHLY_SUBSCRIPTION = 'prod_KCdoYfqaqh5n36'
